import { notification } from "antd";

import history from "../../routes/history";
import api from "../api";
import ApiException from "../exception/ApiException";

const registerVeiculo = async (values) => {
  
  try {
    if (values.placa !== undefined) {
      values.placa = values.placa.toUpperCase();
    }
    
    await api.post("veiculos", values);
    history.push("/veiculos");
    notification.open({
      message: "Veiculo adicionado com sucesso!",
    });
  } catch (error) {
    throw new ApiException(error?.response?.data?.error);
  }
};

const getVeiculo = async (id) => {
  try {
    const { data } = await api.get(`veiculos/${id}`);
    return data;
  } catch (error) {
    throw new ApiException(error?.response?.data?.error);
  }
};

const deleteVeiculo = async (id) => {
  try {
    await api.delete(`veiculos/${id}`);
    notification.open({
      message: "Veiculo deletado com sucesso",
    });
  } catch (error) {
    notification.open({
      message: error.response.data.error,
    });
  }
};

const getVeiculos = async (page, filter = "", paginated = "") => {
  const { data: veiculos } = await api.get(
    `veiculos?page=${page}&filter=${filter}&paginated=${paginated}`
  );
  return veiculos;
};

const updateVeiculo = async (veiculo, values) => {
  try {
    values.id = veiculo.id;
    if (values.placa !== undefined || values.placa !== null) {
      values.placa = values.placa.toUpperCase();
    }
    await api.put("veiculos", values);
    history.push("/veiculos");
    notification.open({
      message: "Veiculo atualizado com sucesso!",
    });
  } catch (error) {
    throw new ApiException(error?.response?.data?.error);
  }
};

export {
  registerVeiculo,
  deleteVeiculo,
  getVeiculo,
  getVeiculos,
  updateVeiculo,
};
